











import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SingleCard extends Vue {
  @Prop() item!: any;
  Categories: any;
  currentRoute: any;
  image: boolean = false;
  get currentRouteName() {
    return this.$route.name;
  }

  getImgUrl(item: any) {
    if (item.iconUrl == null) {
      return item.imageUrl;
    } else {
      this.image = true;
      return item.iconUrl;
    }
  }
}
